<template>
    <div class="container">
        <div class="card">
            <div class="card-header">
                Sukurti naują įrangos tipą
            </div>
            <div class="card-body">

                <div class="form-row">
                    <div class="col-auto">
                        <input type="text" class="form-control" placeholder="Pavadinimas" v-model="new_row.name">
                    </div>

                </div>

                <div class="form-row my-1">
                    <div class="col">

                            <input type="text" class="form-control" placeholder="Aprašymas" v-model="new_row.description">

                    </div>
                </div>

            </div>
            <div class="card-footer">
                <div class="col ">
                    <button class="btn btn-outline-success ml-auto">Įrašyti</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "NewEqiuipmentType",

        data: function () {
            return {
                new_row: {
                    name: '',
                    description: ''
                }
            }
        },
    }
</script>

<style scoped>

</style>